<template>    
    <div class="home">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Horas Personal
        </v-card-title>
        
        <v-layout wrap align-center>
            <v-flex xs10 offset-xs1>
                <v-autocomplete
                    v-model="tarea"
                    :items="tareas"
                    item-text="description"
                    item-value="no"
                    dense
                    filled
                    label="Seleccione una Tarea"
                    clearable
                    :disabled="this.$store.state.indexEditLine > -1"
                ></v-autocomplete>                
            </v-flex>
            <v-flex xs10 offset-xs1>
                <v-autocomplete
                    v-model="familia"
                    :items="familias"
                    item-text="no"
                    item-value="no"
                    dense
                    filled
                    label="Seleccione una Familia"
                    clearable
                    required
                ></v-autocomplete>                
            </v-flex>        
            <!--v-flex xs10 offset-xs1>
                <v-autocomplete
                    v-model="resource"
                    :items="resources"
                    item-text="no"
                    item-value="no"
                    dense
                    filled
                    label="Seleccione un recurso"
                    clearable
                ></v-autocomplete>
            </v-flex-->  
            <v-flex xs10 offset-xs1>
                <v-select
                v-model="workType"
                :items="workTypes"
                item-text="description"
                item-value="code"
                label="Tipo"                
                >
                <template v-slot:no-data>
                    Seleccione Familia
                </template>
                </v-select>
            </v-flex>
            <v-flex v-if="facturableVisible" xs8 >
              <v-text-field v-model="invoiceableCount" type="number" label="Unidad(es) Facturable(s)" append-outer-icon="add" @click:append-outer="incrementI" prepend-icon="remove" @click:prepend="decrementI"></v-text-field>
            </v-flex>
            <v-flex v-if="facturableVisible" xs3>
                <v-select
                v-model="uom"
                :items="uoms"
                item-text="code"
                item-value="code"
                label="Ud."
                >
                <template v-slot:no-data>
                    Seleccione Tarea
                </template>
                </v-select>
            </v-flex>
            
            
            <v-flex xs4 offset-xs1>
                <v-text-field
                label="Desde:"
                v-model="start"
                value="12:00:00"
                type="text"
                inputmode="numeric"
                @change="validateStart"
                @focus="onSelectHourInputStart"
                @blur="onBlurHourInputStart"
                @keyup="formatHourStart"
                autocomplete="off"
                ></v-text-field>
                <!--v-col style="flex: 0 1 auto;">
                    <h2>Desde:</h2>
                    <v-time-picker
                    v-model="start"
                    :max="end"
                    format="24hr"
                    @change="validateStart"
                    ></v-time-picker>
                </v-col-->
            </v-flex>
            <v-flex xs4 offset-xs2>
                <v-text-field
                label="Hasta:"
                v-model="end"
                value="12:30:00"
                type="text"
                inputmode="numeric"
                @change="validateEnd"
                @focus="onSelectHourInputEnd"
                @blur="onBlurHourInputEnd"
                @keyup="formatHourEnd"
                autocomplete="off"
                ></v-text-field>
                <!--v-col style="flex: 0 1 auto;">
                    <h2>Hasta:</h2>
                    <v-time-picker
                    v-model="end"
                    :min="start"
                    format="24hr"
                    @change="validateEnd"
                    ></v-time-picker>
                </v-col-->
            </v-flex>
            <v-flex xs10 offset-xs1>
              <v-text-field autocomplete="off" v-model="hourCount" type="number" label="Total Horas" append-outer-icon="add" @click:append-outer="incrementT" prepend-icon="remove" @click:prepend="decrementT" @change="validateHourCount()"></v-text-field>
            </v-flex>
            
            <!--v-flex xs10 offset-xs1>
               <v-btn
                    color="primary"
                    block
                    @click="openDetails"
                >
                    +Info
                </v-btn>               
            </v-flex-->
            <v-flex xs8 offset-xs1>
                <v-text-field dense autocomplete="off" v-model="albaranFisico" label="Albarán Físico"></v-text-field>
            </v-flex>
            <v-flex xs2 offset-xs1>
                <v-checkbox dense v-model="dieta" label="Dieta"></v-checkbox>
            </v-flex>
            <v-flex xs10 offset-xs1>   
                <v-textarea
                v-model="note"     
                @keyup="checkLength(250)"                    
                >
                <template v-slot:label>
                    <div>
                    Nota <small>(opcional)</small>
                    </div>
                </template>
                </v-textarea>  
            </v-flex>      
        </v-layout>
        
        <br>     
        <br>              
        <br>
        <br>
        <br>
        
        <v-divider></v-divider>       
        <v-footer absolute padless>
            <v-flex v-if="alert" xs10 offset-xs1 mb-3>
            <v-alert
                
                dense
                type="error"
                >
                <span class="alertContent">{{alertContent}}</span>
            </v-alert>
            </v-flex>
            <v-flex 
            v-if="(this.$store.state.indexEditLine != -1) && (this.$store.state.lineasParte[this.$store.state.indexEditLine].etag == undefined)"
            xs10 offset-xs1 mb-3>
                <v-btn small block color="error" dark :disabled="this.$store.state.lineasParte[this.$store.state.indexEditLine].validated" @click="deleteLine">Eliminar</v-btn>
            </v-flex>
            <v-flex xs4 offset-xs1 mb-3>
                <v-btn x-large block color="primary" dark @click="close">Cancelar</v-btn>
            </v-flex>                         
            <br>          
            <v-flex xs4 offset-xs2 mb-3>
                <v-btn x-large block color="success" dark :disabled="(this.$store.state.indexEditLine != -1) && this.$store.state.lineasParte[this.$store.state.indexEditLine].validated" @click="closeOK">Aceptar</v-btn>              
            </v-flex>
        </v-footer>   
    </div>
</template>
<script>
export default {
    name: 'inputHorasPersonal',
    data () {
      return {        
        hourCount: 0,
        invoiceableCount: 0,
        facturableVisible: false,
        alert: false,
        alertContent: '',
        validFrom: false,
        validTo: false
      }
    },
    methods:{   
        formatHourStart(){
            /*if (event.key != 'Backspace'){
                var error = false;
                for (var i = 0; i < this.start.length; i++){
                    if ( ((i != 2) && (this.start.substring(i,i+1) != ':')) && isNaN(Number(this.start.substring(i,i+1))) ){
                        this.start = this.start.substring(0,i) + this.start.substring(i+1);
                        error = true;
                    }
                }
                if (!error && this.start.length == 2){
                    this.start = this.start + ':';
                }
            }*/
        },
        onSelectHourInputStart(){
            if (this.start == '--:--'){
                this.start = '';
            }
        },
        onBlurHourInputStart(){
            if (this.start == ''){
                this.start = '--:--';
            }
        },
        checkLength(max){
            if (this.note.length > max){
                this.note = this.note.slice(0,max);
            }
        },
        /*validateHourStart(){
            let regex = /^([0-1]?[0-9]|2[0-3])[0-5][0-9]$/g;
            let regex_ = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g;
            if (this.start != ''){
                //Comprobamos si la hora esta correcta (con o sin punto)
                var result = regex.test(this.start) || regex_.test(this.start);
                if (!result){
                    this.start = '';
                    this.alertinfoContent = 'Introduzca una hora válida';
                    this.alertinfo = true;
                    var thisaux = this;
                    setTimeout(function(){
                        thisaux.alertinfo = false;
                        thisaux.alertinfoContent = ''
                    },3000);
                } else {
                    //Correcto
                    //Si no tiene punto...
                    if (!regex_.test(this.start)){
                        this.start = this.start.substring(0,this.start.length-2) + ':' + this.start.substring(this.start.length-2);
                    }
                }
            }
        },*/
        formatHourEnd(){
            /*if (event.key != 'Backspace'){
                var error = false;
                for (var i = 0; i < this.end.length; i++){
                    if ( ((i != 2) && (this.end.substring(i,i+1) != ':')) && isNaN(Number(this.end.substring(i,i+1))) ){
                        this.end = this.end.substring(0,i) + this.end.substring(i+1);
                        error = true;
                    }
                }
                if (!error && this.end.length == 2){
                    this.end = this.end + ':';
                }
            }*/
        },
        onSelectHourInputEnd(){
            if (this.end == '--:--'){
                this.end = '';
            }
        },
        onBlurHourInputEnd(){
            if (this.end == ''){
                this.end = '--:--';
            }
        },
        /*validateHourEnd(){
            let regex = /^([0-1]?[0-9]|2[0-3])[0-5][0-9]$/g;
            let regex_ = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g;
            if (this.end != ''){
                var result = regex.test(this.end) || regex_.test(this.end);
                if (!result){
                    this.end = '';
                    this.alertinfoContent = 'Introduzca una hora válida';
                    this.alertinfo = true;
                    var thisaux = this;
                    setTimeout(function(){
                        thisaux.alertinfo = false;
                        thisaux.alertinfoContent = ''
                    },3000);
                } else {
                    //Correcto
                    //Si no tiene punto...
                    if (!regex_.test(this.end)){
                        this.end = this.end.substring(0,this.end.length-2) + ':' + this.end.substring(this.end.length-2);
                    }
                }
            }
        },*/
        validateHourCount(){
            ///if (this.facturableVisible) this.invoiceableCount = this.hourCount;
        },  
        deleteLine(){
            this.$store.state.lineasParte.splice(this.$store.state.indexEditLine,1);
            this.close();
        },   
        close(){
            if (this.hasHistory())
                this.$router.go(-1);
            else
                this.$router.push('Parte');
            //this.$store.commit('saveJobTask','');
            //this.$store.commit('saveFamilia','');
            this.$store.commit('saveWorkType','');
            this.$store.commit('saveUom','');
            //this.$store.commit('saveCodIntCliente','');
            //this.$store.commit('saveOrigen','');
            //this.$store.commit('saveDestino','');
            //this.$store.commit('saveResiduo','');
            this.$store.commit('saveTaskDescription','');
            this.$store.commit('saveHourStart',undefined);
            this.$store.commit('saveHourEnd',undefined);
            this.$store.commit('saveIndexEditLine',-1);
            //this.$store.commit('resetLines');        
        },
        closeOK(){   
            if (!this.validFrom){
                //this.validateStart();
                return;
            }
            if (!this.validTo){
                //this.validateEnd();
                return;
            }
            var thisaux = this;
            if (!this.familia){
                //alert('Debe rellenar la familia');
                this.alertContent = 'Debe rellenar la familia';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
            if (!this.workType){
                //alert('Debe rellenar el tipo de hora');
                this.alertContent = 'Debe rellenar el tipo de hora';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
            if (!this.tarea){
                //alert('Debe rellenar la tarea');
                this.alertContent = 'Debe rellenar la tarea';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
            /*if (!this.resource){
                //alert('Debe rellenar el recurso');
                this.alertContent = 'Debe rellenar el recurso';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }*/
            var famNo = this.familia;
            var familia_data = this.familias.find(fam =>{
                return fam.no == famNo;
            });
            var jobTaskNo = '';
            var tarea_data = {};
            if ((familia_data) && (familia_data.general)) {
                this.proyecto = this.$store.state.appconfig.ProyectoGeneral;
                this.tarea = this.$store.state.appconfig.TareaGeneral;
                tarea_data.no = this.$store.state.appconfig.TareaGeneral;
                tarea_data.description = this.$store.state.appconfig.taskDescription;
                tarea_data.itemNo = this.$store.state.appconfig.taskItemNo;
            }
            var jobNo = this.proyecto;
            var proyecto_data = this.proyectos.find(proyecto =>{
                return proyecto.no == jobNo;
            });
            if ((familia_data) && (!familia_data.general)) {
                jobTaskNo = this.tarea;
                tarea_data = this.tareas.find(tarea =>{
                    return tarea.no == jobTaskNo;
                });
            }
            
            /*if (tarea_data.OrigenObligatorio && !this.$store.state.origen){
                //alert('Debe rellenar el origen');                
                this.alertContent = 'Debe rellenar el origen';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
            if (tarea_data.DestinoObligatorio && !this.$store.state.destino){
                //alert('Debe rellenar el destino');
                this.alertContent = 'Debe rellenar el destino';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }
            if (tarea_data.Cod_InternoCliObliga && !this.$store.state.codIntCliente){
                //alert('Debe rellenar el cód. interno cliente');
                this.alertContent = 'Debe rellenar el cód. interno cliente';
                this.alert = true;
                setTimeout(function(){
                    thisaux.alert = false;
                    thisaux.alertContent = ''
                },3000);
                return;
            }*/
            
            /*var persLinesAll = this.lineas.filter(lin =>{
                return (lin.jobNo == proyecto_data.no) && (lin.invoiceableCountUom == '');
            });*/
            var fromHour = new Date("01/01/1754 " + this.start + ':00');
            var toHour = new Date("01/01/1754 " + this.end + ':00');
            var checkHours = true;
            //persLinesAll.forEach(lin => {
            for (var j = 0; j < this.lineas.length; j++){
                if (this.lineas[j].invoiceableCountUom != '') continue; //Ignoramos las de facturacion
                if (this.lineas[j].adicional) continue; //Ignoramos las lineas de recursos adicionales (en caso de que estemos editando un parte ya enviado a nav)
                if (j == this.$store.state.indexEditLine) continue; //Si es una edicion, ignoramos la linea en memoria que estamos editando
                var lin = this.lineas[j];
                var fromHourLin = new Date("01/01/1754 " + lin.startTime + ':00');
                var toHourLin = new Date("01/01/1754 " + lin.endTime + ':00');
                if (fromHour < fromHourLin){
                    if (toHour > fromHourLin){
                        this.alertContent = 'Horas solapadas. No puede imputar horas mas allá de las ' + lin.startTime + '.';
                        this.alert = true;
                        setTimeout(function(){
                            thisaux.alert = false;
                            thisaux.alertContent = ''
                        },3000);
                        checkHours = false;
                    }
                } else if (fromHour > fromHourLin){
                    if (fromHour < toHourLin){
                        this.alertContent = 'Horas solapadas. No puede imputar horas antes de las ' + lin.endTime + '.';
                        this.alert = true;
                        setTimeout(function(){
                            thisaux.alert = false;
                            thisaux.alertContent = ''
                        },3000);
                        checkHours = false;
                    }
                } else { //igual
                    this.alertContent = 'Horas solapadas. Ya existe una linea con la misma hora ' + lin.startTime + '.';
                    this.alert = true;
                    setTimeout(function(){
                        thisaux.alert = false;
                        thisaux.alertContent = ''
                    },3000);
                    checkHours = false;
                }
            //});
            }
            if (!checkHours) return;
            if (this.$store.state.indexEditLine > -1){
                //Linea en edición
                var i = this.$store.state.indexEditLine;
                this.lineas[i].jobNo = proyecto_data.no;
                this.lineas[i].jobName = proyecto_data.description;
                this.lineas[i].jobTaskNo= tarea_data.no;
                this.lineas[i].jobTaskName= tarea_data.description;
                this.lineas[i].jobTaskLabel= tarea_data.no + ' - ' + tarea_data.description;
                this.lineas[i].Proyecto= proyecto_data.no + ' - ' + proyecto_data.description;
                this.lineas[i].hourCount= this.hourCount;
                this.lineas[i].jobTaskItemNo = tarea_data.itemNo;
                this.lineas[i].invoiceableCount= 0;
                this.lineas[i].invoiceableCountUom= '';
                this.lineas[i].familia= this.familia;
                this.lineas[i].workType= this.workType;
                this.lineas[i].startTime= this.start;
                this.lineas[i].endTime= this.end;
                this.lineas[i].signatureStart= this.$store.state.signatureStart;
                this.lineas[i].signatureEnd= this.$store.state.signatureEnd;
                this.lineas[i].origen=  this.$store.state.origen;
                this.lineas[i].destino=  this.$store.state.destino;
                this.lineas[i].residuo= this.$store.state.otroResiduo == '' ? this.$store.state.residuo : this.$store.state.otroResiduo;
                this.lineas[i].albaranFisico=  this.$store.state.albaranFisico;
                this.lineas[i].dieta=  this.$store.state.dieta;
                this.lineas[i].codIntCliente=  this.$store.state.codIntCliente;
                this.lineas[i].taskDescription=  this.$store.state.taskDescription;                
                this.lineas[i].resource= this.$store.state.usuario.resource;
                this.lineas[i].note= this.note;
                //Para la edicion, si hay recursos adicionales, actualizamos sus lineas
                var lineNo_ = this.lineas[i].lineNo;
                var aditionalLines = this.lineas.filter(lin =>{
                    return ((lin.adicional) && (lin.resourceLine == lineNo_));
                }); 
                aditionalLines.forEach(aditionalLine => {
                    aditionalLine.hourCount= this.hourCount;
                    aditionalLine.jobTaskItemNo = tarea_data.itemNo;
                    aditionalLine.familia= this.familia;
                    aditionalLine.workType= this.workType;
                    aditionalLine.startTime= this.start;
                    aditionalLine.endTime= this.end;
                });
            } else {
                //Linea nueva
                var lineNo = 10000;
                if (this.lineas.length > 0){
                    lineNo += this.lineas[this.lineas.length-1].lineNo;
                }
                var line = {
                    lineNo : lineNo,
                    jobNo : proyecto_data.no,
                    jobName : proyecto_data.description,
                    jobTaskNo: tarea_data.no,
                    jobTaskName: tarea_data.description,
                    jobTaskLabel: tarea_data.no + ' - ' + tarea_data.description,
                    Proyecto: proyecto_data.no + ' - ' + proyecto_data.description,
                    hourCount: this.hourCount,
                    jobTaskItemNo : tarea_data.itemNo,
                    invoiceableCount: 0,
                    invoiceableCountUom: '',
                    familia: this.familia,
                    workType: this.workType,
                    startTime: this.start,
                    endTime: this.end,
                    signatureStart: this.$store.state.signatureStart,
                    signatureEnd: this.$store.state.signatureEnd,
                    origen:  this.$store.state.origen,
                    destino:  this.$store.state.destino,
                    residuo: this.$store.state.otroResiduo == '' ? this.$store.state.residuo : this.$store.state.otroResiduo,
                    albaranFisico:  this.$store.state.albaranFisico,
                    dieta:  this.$store.state.dieta,
                    codIntCliente:  this.$store.state.codIntCliente,
                    taskDescription:  this.$store.state.taskDescription,                    
                    resource: this.$store.state.usuario.resource,
                    note: this.note,
                    invoiceableLine: 0,
                    resourceLine: 0
                };
                this.$store.commit('addLine',line);
            }   
            var persLines = this.lineas.filter(lin =>{
                return (lin.jobNo == proyecto_data.no) && (lin.jobTaskNo == tarea_data.no) && (lin.invoiceableCountUom == '') && (lin.familia == thisaux.familia) && (lin.workType == thisaux.workType) && (!lin.adicional);
            });    
            var totalHour  = 0;
            persLines.forEach(persLine => {
                totalHour += parseFloat(persLine.hourCount);
            });
            var invoLine = null;
            //buscamos la linea facturable. Si es una linea de personal nueva, la buscamos por tipo de hora
            //si es en edicion, buscamos la relacionada por el campo invoiceableLine
            if (this.$store.state.indexEditLine > -1){//edicion
                invoLine = this.lineas.find(lin =>{
                    return (lin.lineNo == this.lineas[this.$store.state.indexEditLine].invoiceableLine);
                });
            } else { //nueva
                invoLine = this.lineas.find(lin =>{
                    return (lin.jobNo == proyecto_data.no) && (lin.jobTaskNo == tarea_data.no) && (lin.invoiceableCountUom != '') && (lin.familia == thisaux.familia) && (lin.workType == thisaux.workType);
                });
            }
            //Si aun asi la linea de facturacion no se encuentra, es que el tipo de hora modificado o insertado en la linea de personal no tiene linea de facturacion
            //en ese caso, buuscamos la primera linea de facturacion, borramos su etag en caso de que sea una modificacion de un parte, y le ponemos el tipo de hora correspondiente
            if (invoLine == undefined){
                invoLine = this.lineas.find(lin =>{
                    return (lin.jobNo == proyecto_data.no) && (lin.jobTaskNo == tarea_data.no) && (lin.invoiceableCountUom != '') && (lin.familia == thisaux.familia);
                });
                if (invoLine == undefined){
                    invoLine = this.lineas.find(lin =>{
                        return (lin.jobNo == proyecto_data.no) && (lin.jobTaskNo == tarea_data.no) && (lin.invoiceableCountUom != '');
                    });
                }
                if (invoLine && (invoLine.workType != '')){
                    lineNo = 10000;
                    /*if (this.lineas.length > 0){
                        lineNo += this.lineas[this.lineas.length-1].lineNo;
                    }*/
                    var factLines = this.lineas.filter(lin =>{
                        return (lin.jobNo == proyecto_data.no) && (lin.jobTaskNo == tarea_data.no) && (lin.invoiceableCountUom != '');
                    });
                    lineNo += factLines.length * 10;
                    var lineClone = JSON.parse(JSON.stringify(invoLine));
                    lineClone.etag = ''; 
                    lineClone.lineNo = lineNo;
                    lineClone.workType = this.workType;
                    lineClone.familia = this.familia;
                    lineClone.invoiceableCount = 0;
                    lineClone.startTimeInvoiceable = this.start;
                    lineClone.endTimeInvoiceable = this.end;
                    this.$store.commit('addLine',lineClone);
                    invoLine = this.lineas.find(lin =>{
                        return (lin.jobNo == proyecto_data.no) && (lin.jobTaskNo == tarea_data.no) && (lin.invoiceableCountUom != '') && (lin.familia == thisaux.familia) && (lin.workType == thisaux.workType);
                    });
                }
            }
            if (invoLine != undefined){
                invoLine.hourCount = parseFloat(totalHour);
                invoLine.workType = this.workType;
                if (this.$store.state.indexEditLine > -1){//edicion
                    this.lineas[this.$store.state.indexEditLine].invoiceableLine = invoLine.lineNo;
                    var lineNo__ = this.lineas[this.$store.state.indexEditLine].lineNo;
                    var aditionalLines_ = this.lineas.filter(lin =>{
                        return ((lin.adicional) && (lin.resourceLine == lineNo__));
                    }); 
                    aditionalLines_.forEach(aditionalLine => {
                        aditionalLine.invoiceableLine= invoLine.lineNo;
                    });
                } else {//nueva
                    this.lineas[this.lineas.length-1].invoiceableLine = invoLine.lineNo;
                }
                console.log(invoLine);
            }
            //Se limpian los campos del formulario
            //this.$store.commit('saveJobTask','');
            //this.$store.commit('saveFamilia','');
            this.$store.commit('saveWorkType','');
            this.$store.commit('saveUom','');
            //this.$store.commit('saveCodIntCliente','');
            //this.$store.commit('saveOrigen','');
            //this.$store.commit('saveDestino','');
            //this.$store.commit('saveResiduo','');
            this.$store.commit('saveNote','');
            this.$store.commit('saveTaskDescription','');
            this.$store.commit('saveHourStart',undefined);
            this.$store.commit('saveHourEnd',undefined);
            this.$store.commit('saveIndexEditLine',-1);
            if (this.hasHistory())
                this.$router.go(-1);
            else
                this.$router.push('Parte');                       
        },
        incrementT () {
          this.hourCount = parseInt(this.hourCount,10) + 1;
          this.validateHourCount();
        },
        decrementT () {
          this.hourCount = parseInt(this.hourCount,10) - 1;
          this.validateHourCount();
        },
        incrementI () {
          this.invoiceableCount = parseInt(this.invoiceableCount,10) + 1
        },
        decrementI () {
          this.invoiceableCount = parseInt(this.invoiceableCount,10) - 1
        },
        jobTaskCaption(item){
            return item.no + ' - ' + item.description;
        }, 
        validateStart(){    
            var thisaux = this;
            let regex = /^([0-1]?[0-9]|2[0-3])[0-5][0-9]$/g;
            let regex_ = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g;
            var a = regex.test(this.start);
            var b = regex_.test(this.start);
            if (this.start != ''){
                //Comprobamos si la hora esta correcta (con o sin punto)
                var result_reg = a || b;
                if (!result_reg){
                    this.start = '';
                    this.alertinfoContent = 'Introduzca una hora válida';
                    this.alertinfo = true;
                    setTimeout(function(){
                        thisaux.alertinfo = false;
                        thisaux.alertinfoContent = ''
                    },3000);
                    return;
                } else {
                    //Correcto
                    //Si no tiene punto...
                    if (!b){
                        this.start = this.start.substring(0,this.start.length-2) + ':' + this.start.substring(this.start.length-2);
                    }
                }
            } else {
                return;
            }
            if ((this.end != undefined) && (this.end != '--:--') && (this.end != '')){
                var fromHour = new Date("01/01/1754 " + this.start + ':00');
                var toHour = new Date("01/01/1754 " + this.end + ':00');
                
                var workTypeData = this.workTypes.find(wt =>{
                    return (wt.code == thisaux.workType) && (wt.familia == thisaux.familia);
                });
                var fromHourNAV = new Date(workTypeData.fromHour);
                var toHourNAV = new Date(workTypeData.toHour);
                if (((fromHourNAV > fromHour) || (toHourNAV < toHour))){
                    this.alertContent = 'Horas fuera del rango ' + fromHourNAV.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }) + ' - ' + toHourNAV.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
                    this.alert = true;
                    setTimeout(function(){
                        thisaux.alert = false;
                        thisaux.alertContent = ''
                    },3000);
                    if (fromHourNAV > fromHour){
                        this.start = undefined;
                        this.end = undefined;
                    }
                    if (toHourNAV < toHour){
                        this.start = undefined;
                        this.end = undefined;
                    }
                    return;
                }

                var result = toHour - fromHour;
                
                this.hourCount = parseFloat((result/3600000).toFixed(2));
                this.invoiceableCount = parseFloat((result/3600000).toFixed(2));
            }
            //Solo se abre si la linea es nueva
            if (this.$store.state.indexEditLine == -1) this.$store.state.dialogSignatureHourStart = true;
            setTimeout(function(){
                thisaux.validFrom = true;
            },500);
            
        },
        validateEnd(){
            var thisaux = this;
            let regex = /^([0-1]?[0-9]|2[0-3])[0-5][0-9]$/g;
            let regex_ = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g;
            var a = regex.test(this.end);
            var b = regex_.test(this.end);
            if (this.end != ''){
                var result_reg = a || b;
                if (!result_reg){
                    this.end = '';
                    this.alertinfoContent = 'Introduzca una hora válida';
                    this.alertinfo = true;
                    setTimeout(function(){
                        thisaux.alertinfo = false;
                        thisaux.alertinfoContent = ''
                    },3000);
                    return;
                } else {
                    //Correcto
                    //Si no tiene punto...
                    if (!b){
                        this.end = this.end.substring(0,this.end.length-2) + ':' + this.end.substring(this.end.length-2);
                    }
                }
            } else {
                return;
            }
            if ((this.start != undefined) && (this.start != '--:--') && (this.start != '')){
                var fromHour = new Date("01/01/1754 " + this.start + ':00');
                var toHour = new Date("01/01/1754 " + this.end + ':00');
                
                var workTypeData = this.workTypes.find(wt =>{
                    return (wt.code == thisaux.workType) && (wt.familia == thisaux.familia);
                });
                var fromHourNAV = new Date(workTypeData.fromHour);
                var toHourNAV = new Date(workTypeData.toHour);
                if (((fromHourNAV > fromHour) || (toHourNAV < toHour))){
                    this.alertContent = 'Horas fuera del rango ' + fromHourNAV.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }) + ' - ' + toHourNAV.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
                    this.alert = true;
                    setTimeout(function(){
                        thisaux.alert = false;
                        thisaux.alertContent = ''
                    },3000);
                    if (fromHourNAV > fromHour){
                        this.start = undefined;
                        this.end = undefined;
                    }
                    if (toHourNAV < toHour){
                        this.start = undefined;
                        this.end = undefined;
                    }
                    return;
                }

                var result = toHour - fromHour;
                
                this.hourCount = parseFloat((result/3600000).toFixed(2));
                this.invoiceableCount = parseFloat((result/3600000).toFixed(2));
            }
            //Solo se abre si la linea es nueva
            if (this.$store.state.indexEditLine == -1) this.$store.state.dialogSignatureHourEnd = true;
            setTimeout(function(){
                thisaux.validTo = true;
            },500);
        },        
        openDetails(){
            this.$store.state.dialogExtraInfo = true;
        }
    },
    mounted(){
        
        console.log(this.$store.state.lineasParte);
        var filteredLines = this.lineas.filter(linea => !linea.adicional);
        if ((this.$store.state.indexEditLine > -1) && (this.$store.state.lineasParte.length > 0)){
            var i = this.$store.state.indexEditLine;
            //Linea en edición, se rellenan los datos de la linea
            this.hourCount = filteredLines[i].hourCount;
            this.invoiceableCount = filteredLines[i].invoiceableCount;
            this.$store.commit('saveJob',filteredLines[i].jobNo);
            this.$store.commit('saveJobTask',filteredLines[i].jobTaskNo);
            this.$store.commit('saveFamilia',filteredLines[i].familia);
            this.$store.commit('saveWorkType',filteredLines[i].workType);
            this.$store.commit('saveUom',filteredLines[i].invoiceableCountUom);
            this.$store.commit('saveHourStart',filteredLines[i].startTime);
            this.$store.commit('saveHourEnd',filteredLines[i].endTime);
            this.$store.commit('saveOrigen',filteredLines[i].origen);
            this.$store.commit('saveDestino',filteredLines[i].destino);
            this.$store.commit('saveResiduo',filteredLines[i].residuo);
            this.$store.commit('saveAlbaranFisico',filteredLines[i].albaranFisico);
            this.$store.commit('saveDieta',filteredLines[i].dieta);
            this.$store.commit('saveCodIntCliente',filteredLines[i].codIntCliente);
            this.$store.commit('saveTaskDescription',filteredLines[i].taskDescription);
            this.$store.commit('saveResource',filteredLines[i].resource);
            this.$store.commit('saveNote',filteredLines[i].note);
            
            this.getJobTasks(this.proyecto); 
            this.getFamilias(this.proyecto);       
            this.alert = false;
            this.alertContent = '';
            this.validFrom = true;
            this.validTo = true;
        } else { 
            //Linea nueva
            this.$store.commit('saveIndexEditLine',-1);
            this.start = '--:--';
            this.end = '--:--';
            this.hourCount = 0;
            this.invoiceableCount = 0;
            this.getJobTasks(this.proyecto); 
            this.$store.commit('saveWorkTypes',[]);
            this.$store.commit('saveWorkType','')
            this.getFamilias(this.proyecto);          
            this.validFrom = false;
            this.validTo = false;          
        }
        //Comun para nuevas y creacion
        if (this.familia) {
            this.getWorkTypes();
        }
        /*if (this.tarea){
            var jobTaskNo = this.tarea;
            var jobTaskData = this.tareas.find(t =>{
                return t.no == jobTaskNo;
            });                    
            if (jobTaskData.horasPersonalFacturable){
                this.facturableVisible = true;
                this.getJobTaskItemUom(jobTaskData.itemNo);
            } else {
                this.facturableVisible = false;
            }
        }*/
        this.getResources();
    },
    watch:{
        /*tarea: function(val){
            if (val){
                var jobTaskNo = this.tarea;
                var jobTaskData = this.tareas.find(t =>{
                    return t.no == jobTaskNo;
                });
                if (jobTaskData.horasPersonalFacturable){
                    this.facturableVisible = true;
                    this.getJobTaskItemUom(jobTaskData.itemNo);
                } else {
                    this.facturableVisible = false;
                }
                
            } else {
                this.$store.commit('saveUoms',[]);
                this.$store.commit('saveUom','');
            }
        },*/
        familia: function (val){
            if (val){
                this.getWorkTypes();
            }
        },        
        /*start: function (val){
            if (val)
                //console.log(val);
                this.$store.state.dialogSignatureHourStart = true;
        },
        end: function (val){
            if (val)
                //console.log(val);
                this.$store.state.dialogSignatureHourEnd = true;
        }*/
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogInputHorasPersonal;
            },
            set(value){
                this.$store.state.dialogInputHorasPersonal = value;
            }
        },
        proyectos:{
            get(){
                return this.$store.state.allJobs;
            }
        },
        tareas:{
            get(){
                return this.$store.state.jobTasks;
            }
        },
        proyecto:{
            get(){
                return this.$store.state.proyecto;
            },
            set(value){
                //this.$store.state.proyecto = value;
                this.$store.commit('saveJob',value);
            }
        },
        tarea:{
            get(){
                return this.$store.state.tarea;
            },
            set(value){
                //this.$store.state.tarea = value;
                this.$store.commit('saveJobTask',value);
            }
        },
        uoms:{
            get(){
                return this.$store.state.uoms;
            },
            set(value){                
                this.$store.commit('saveUoms',value);
            }
        },
        uom:{
            get(){
                return this.$store.state.uom;
            },
            set(value){                
                this.$store.commit('saveUom',value);
            }
        },
        resources:{
            get(){
                return this.$store.state.resources;
            },
            set(value){                
                this.$store.commit('saverResources',value);
            }
        },
        resource:{
            get(){
                return this.$store.state.resource;
            },
            set(value){                
                this.$store.commit('saveResource',value);
            }
        },
        familias:{
            get(){
                return this.$store.state.familias;
            },
            set(value){                
                this.$store.commit('saveFamilias',value);
            }
        },
        familia:{
            get(){
                return this.$store.state.familia;
            },
            set(value){                
                this.$store.commit('saveFamilia',value);
            }
        },
        workTypes:{
            get(){
                return this.$store.state.workTypes;
            },
            set(value){                
                this.$store.commit('saveWorkTypes',value);
            }
        },
        workType:{
            get(){
                return this.$store.state.workType;
            },
            set(value){                
                this.$store.commit('saveWorkType',value);
            }
        },
        start: {
            get(){
                return this.$store.state.hourStart;
            },
            set(value){                
                this.$store.commit('saveHourStart',value);
            }
        },
        end:{
            get(){
                return this.$store.state.hourEnd;
            },
            set(value){                
                this.$store.commit('saveHourEnd',value);
            }
        },
        note:{
            get(){
                return this.$store.state.note;
            },
            set(value){                
                this.$store.commit('saveNote',value);
            }
        },
        lineas:{
            get(){
                return this.$store.state.lineasParte;
            },
            set(value){                
                this.$store.commit('setLines',value);
            }       
        },
        albaranFisico:{
            get(){
                return this.$store.state.albaranFisico;
            },
            set(value){
                this.$store.commit('saveAlbaranFisico', value);
            }
        },
        dieta:{
            get(){
                return this.$store.state.dieta;
            },
            set(value){
                this.$store.commit('saveDieta', value);
            }
        }
    }
}
</script>

